export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 dark:border-white/10 bg-white dark:bg-[#050505] text-zinc-600 dark:text-zinc-400">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 text-sm font-mono">
        <div>
          <div className="font-display font-black text-zinc-900 dark:text-white text-lg mb-3 tracking-tighter uppercase">ILFAL</div>
          <p className="leading-relaxed text-zinc-500">Interactive Labs for Advanced Learning. Hands-on AI security training — attack and defend real LLM systems.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-700 dark:text-zinc-300 mb-3">Platform</div>
          <ul className="space-y-1.5">
            <li><a href="/#curriculum" className="hover:text-[#FF3B30] transition-colors">Curriculum</a></li>
            <li><a href="/#why" className="hover:text-[#FF3B30] transition-colors">Why ILFAL</a></li>
            <li><a href="/#pricing" className="hover:text-[#FF3B30] transition-colors">Pricing</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-700 dark:text-zinc-300 mb-3">Support</div>
          <p className="text-zinc-500">Questions or help? Email us at<br />
            <a href="mailto:support@ilfal.com" data-testid="footer-support-email" className="text-[#00B8CC] dark:text-[#00E5FF] hover:text-[#FF3B30] transition-colors">support@ilfal.com</a>
          </p>
          <p className="mt-2"><a href="/contact" data-testid="footer-contact-link" className="hover:text-[#FF3B30] transition-colors">Help &amp; contact →</a></p>
          <p className="mt-3 text-zinc-500">Public certificate verification at <span className="text-[#00B8CC] dark:text-[#00E5FF]">ilfal.com/verify/&#123;id&#125;</span></p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-700 dark:text-zinc-300 mb-3">Legal</div>
          <ul className="space-y-1.5">
            <li><a href="/terms" data-testid="footer-terms-link" className="hover:text-[#FF3B30] transition-colors">Terms of Service</a></li>
            <li><a href="/privacy" data-testid="footer-privacy-link" className="hover:text-[#FF3B30] transition-colors">Privacy Policy</a></li>
            <li><a href="/refund-policy" data-testid="footer-refund-link" className="hover:text-[#FF3B30] transition-colors">Refund Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200 dark:border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 text-xs font-mono text-zinc-500 dark:text-zinc-600 flex flex-wrap justify-between gap-2">
          <span>© 2026 ILFAL // ALL RIGHTS RESERVED</span>
          <span>v0.2.0</span>
        </div>
      </div>
    </footer>
  );
}
